import * as React from 'react';
import { useDispatch } from 'react-redux';
import styles from './storyitem.module.scss';
import FileItem from '../FileItem';
import { File } from '../../store/Story/modal';
import moment from 'moment';
import { useTypedSelector } from '../../store';
import { ApplicationState } from '../../store/appThunkAction';
import envConfig from '../../config';
import { selectRecommendationItem } from '../../store/Meeting/actions';
import { openWindow } from '../../utils/dialog';


const RecommandataionFileItems = () => {
    const dispatch = useDispatch();
    let items: File[] = [];
    const {
        stories: cacheStories
    } = useTypedSelector((state: ApplicationState) => state.story);

    const {
        selectRecommendedStory,
        selectedFiles,
        currentMeeting
    } = useTypedSelector((state: ApplicationState) => state.meeting);
    const onItemSelected = (fileId: number) => {
        const hubUrl = `https://app.bigtincan.com/file/p/${fileId}`;
        openWindow(hubUrl);
        // dispatch(selectRecommandationStory(id, filterFiles.map(c=>c.id)))
    }
    const currentSelectedStory = cacheStories[selectRecommendedStory];
    if(currentSelectedStory) {

        items = (currentSelectedStory.files || []).filter((c: any) => envConfig.invalidCategory.indexOf(c.category) < 0) as unknown as File[];
    }
    const onItemCheckedChanged =(fileId: number, checked: boolean) => {
        dispatch(selectRecommendationItem(fileId, checked))
    };

    return (
        <div className={styles.container}>
            {items.map(({
                id,
                category,
                cover_art_url,
                created_at,
                description
            }) => {
                let date = "";
                if (created_at) {
                    date = moment(new Date((created_at) * 1000)).format("MMM D");
                }
                let checked = false;
                const currentFileitem = selectedFiles.find(c=>c.id === id);
                if(currentFileitem) {
                    checked = currentFileitem.checked;
                }

                const isAlreadyAdded = !!currentMeeting.meetingContents.find(c=>c.fileId === id);
                return <FileItem
                    key={id}
                    category={category}
                    onCheckedItemChange={onItemCheckedChanged}
                    showChecked={true}
                    disable={isAlreadyAdded}
                    checked={checked || isAlreadyAdded}
                    onItemClick={() => onItemSelected(id)}
                    metaData={date}
                    id={id}
                    title={description}
                    thumbnail={cover_art_url} />

            })}

        </div>
    )
};

export default RecommandataionFileItems;